import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Features from "../components/Features";
import MockupsSection from "../components/MockupsSection";
import Footer from "../components/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#eff6ff] overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <MockupsSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
